import { jsx as _jsx } from "react/jsx-runtime";
import { Component, createContext } from 'react';
export const ErrorContext = /*#__PURE__*/ createContext({});
export class ErrorBoundary extends Component {
    state = {};
    static getDerivedStateFromError(outerError) {
        return {
            outerError
        };
    }
    render() {
        return /*#__PURE__*/ _jsx(ErrorContext.Provider, {
            value: this.state,
            children: this.props.children
        });
    }
}

//# sourceMappingURL=ErrorBoundary.js.map